import * as Yup from "yup";

export const UpdateCitySchema = Yup.object().shape({
  name: Yup.string().required("City name must be filled in"),
  country: Yup.string().required("Country name must be filled in"),
  lat: Yup.number().required("Coordinates are required"),
  lng: Yup.number().required("Coordinates are required"),
});
